import type { State } from '../../types';

export function getOrganizationId(state: State): number {
  if (state.id === null) {
    return 0;
  }
  return state.id;
}
